import { useState } from 'react';
import {
    TextField, Button, Stack, Alert, Box, Typography,
    ToggleButtonGroup, ToggleButton,
} from '@mui/material';
import { Surface } from '../../components/primitives';
import { adminFetch, normalizeEmail } from '../../utils/authUtils';

export default function EmailPanel() {
    const [to, setTo] = useState('');
    const [subject, setSubject] = useState('');
    const [body, setBody] = useState('');
    const [mode, setMode] = useState('text');
    const [busy, setBusy] = useState(false);
    const [status, setStatus] = useState(null);

    const send = async () => {
        setBusy(true); setStatus(null);
        try {
            const data = await adminFetch('/admin/email/send', {
                to: normalizeEmail(to),
                subject,
                body_text: mode === 'text' ? body : undefined,
                body_html: mode === 'html' ? body : undefined,
            });
            setStatus({ kind: 'ok', msg: `Sent · ${data.message_id}` });
            setTo(''); setSubject(''); setBody('');
        } catch (e) {
            setStatus({ kind: 'err', msg: e.message });
        } finally {
            setBusy(false);
        }
    };

    return (
        <Surface>
            <Typography variant="h3" sx={{ color: 'text.primary', mb: 0.5 }}>
                Send email
            </Typography>
            <Typography variant="caption" sx={{ color: 'text.muted', display: 'block', mb: 3 }}>
                From donotreply@capitolgains.io
            </Typography>

            {status && (
                <Alert severity={status.kind === 'ok' ? 'success' : 'error'} sx={{ mb: 2 }}>
                    {status.msg}
                </Alert>
            )}

            <Stack spacing={2}>
                <TextField label="To" value={to} onChange={e => setTo(e.target.value)} fullWidth size="small" />
                <TextField label="Subject" value={subject} onChange={e => setSubject(e.target.value)} fullWidth size="small" />

                <Box>
                    <ToggleButtonGroup
                        value={mode}
                        exclusive
                        size="small"
                        onChange={(_, v) => v && setMode(v)}
                        sx={{ mb: 1 }}
                    >
                        <ToggleButton value="text">Plain</ToggleButton>
                        <ToggleButton value="html">HTML</ToggleButton>
                    </ToggleButtonGroup>
                    <TextField
                        label={mode === 'html' ? 'HTML body' : 'Plain text body'}
                        value={body}
                        onChange={e => setBody(e.target.value)}
                        multiline
                        rows={10}
                        fullWidth
                        sx={{ '& textarea': { fontFamily: t => mode === 'html' ? t.typography.fontFamilyMono : undefined } }}
                    />
                </Box>

                <Button
                    variant="contained"
                    onClick={send}
                    disabled={busy || !to || !subject || !body}
                    sx={{ alignSelf: 'flex-start' }}
                >
                    {busy ? 'Sending…' : 'Send email'}
                </Button>
            </Stack>
        </Surface>
    );
}
